import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBookingServicesFooterComponent } from './my-booking-services-footer.component';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [MyBookingServicesFooterComponent],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule],
  exports: [MyBookingServicesFooterComponent],
})
export class MyBookingServicesFooterModule {}
